<template>
  <div class="warpper">
    <HeadNei :active="'Center'" />
    <div class="content">
      <!--
      <div class="meas_box">
        <el-row :gutter="30">
          <el-col :span="8">
            <div class="poli-cell whole-bgt">
              <div class="poli_head whole-bgt">
                <div class="meas-name"><span>存栏量趋势</span></div>
                <el-select
                  v-model="trendValue"
                  placeholder="全部"
                  @change="handleTrendChange"
                  popper-class="selectPopper"
                  :popper-append-to-body="false"
                >
                  <el-option
                    v-for="item in selectOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <trend-line-charts
                width="100%"
                height="250PX"
                :data="exitTrendData"
              />
            </div>
          </el-col>
          <el-col :span="8">
            <div class="poli-cell whole-bgt">
              <div class="poli_head whole-bgt">
                <div class="meas-name"><span>养殖场畜禽排行</span></div>
                <el-cascader
                  id="rankCascader"
                  v-model="rankValue"
                  :options="rankOption"
                  popper-class="rankPopper"
                  :append-to-body="false"
                  @change="handleRankChange"
                ></el-cascader>
              </div>
              <rank-bar-charts
                width="100%"
                height="250PX"
                :data="farmRankData"
              />
            </div>
          </el-col>
          <el-col :span="8">
            <div class="poli-cell whole-bgt">
              <div class="poli_head whole-bgt">
                <div class="meas-name"><span>入栏、出栏数据对比</span></div>
              </div>
              <contrast-bar-charts
                width="100%"
                height="250PX"
                :data="contrastData"
              />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="poli-cell meas-cell whole-bgt">
              <div class="poli_head meas-head whole-bgt">
                <div class="meas-name"><span>牛只分类统计</span></div>
              </div>
              <assortPieCharts
                width="100%"
                height="130px"
                :data="cattleAssortData"
              />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="poli-cell meas-cell whole-bgt">
              <div class="poli_head meas-head whole-bgt">
                <div class="meas-name"><span>牛只规模养殖场分布</span></div>
              </div>
              <scale-pie-charts
                width="100%"
                height="130px"
                :data="cattleScaleData"
              />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="poli-cell meas-cell whole-bgt">
              <div class="poli_head meas-head whole-bgt">
                <div class="meas-name"><span>羊只分类统计</span></div>
              </div>
              <assortPieCharts
                width="100%"
                height="130px"
                :data="sheepAssortData"
              />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="poli-cell meas-cell whole-bgt">
              <div class="poli_head meas-head whole-bgt">
                <div class="meas-name"><span>羊只规模养殖场分布</span></div>
              </div>
              <scale-pie-charts
                width="100%"
                height="130px"
                :data="sheepScaleData"
              />
            </div>
          </el-col>
          <el-col :span="8">
            <div class="poli-cell whole-bgt">
              <div class="poli_head whole-bgt">
                <div class="meas-name"><span>防疫接种统计</span></div>
              </div>
              <div id="myChart8"></div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="poli-cell whole-bgt">
              <div class="poli_head whole-bgt">
                <div class="meas-name"><span>出生、死亡数统计</span></div>
              </div>
              <sta-line-charts
                width="100%"
                height="250px"
                :data="lifeStaData"
              />
            </div>
          </el-col>
          <el-col :span="8">
            <div class="poli-cell whole-bgt">
              <div class="poli_head whole-bgt">
                <div class="meas-name"><span>主要饲料消耗量统计</span></div>
              </div>
              <div id="myChart9"></div>
            </div>
          </el-col>
        </el-row>
      </div>
	-->
      <!-- 修改后 -->
      <div class="meas_box">
        <el-row :gutter="30">
          <!-- 左侧 -->
          <el-col class="echartsLeft" :span="8">
            <div class="poli-cell whole-bgt" id="rank">
              <div class="poli_head whole-bgt">
                <div class="meas-name"><span>各村畜禽排行</span></div>
                <!-- <el-cascader
                  id="rankCascader"
                  v-model="rankValue"
                  :options="rankOption"
                  popper-class="rankPopper"
                  :append-to-body="false"
                  @change="handleRankChange"
                ></el-cascader> -->
              </div>
              <!-- :height="farmRankData.length === 1 ? '100px' : '850px'" -->
              <rank-bar-charts
                v-if="farmRankData.length !== 0"
                width="100%"
                :height="farmRankHeight"
                id="myChart6"
                :data="farmRankData"
              />
            </div>
          </el-col>
          <!-- 中间 -->
          <el-col class="echartsCenter" :span="8">
            <div style="height: 95%; width: 100%">
              <el-row class="top" :gutter="30">
                <el-col :span="12">
                  <div class="m-select-group">
                    <el-select
                      v-model="currentRegion"
                      placeholder="红寺堡区"
                      @change="handleChangeRegion"
                      popper-class="selectPopper"
                      :popper-append-to-body="false"
                    >
                      <el-option
                        v-for="item in selectOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="m-select-group">
                    <el-select
                      v-model="cattleOrSheep"
                      @change="handleChangeType"
                      popper-class="selectPopper"
                      :popper-append-to-body="false"
                    >
                      <el-option label="牛产业视图" value="1"></el-option>
                      <el-option label="羊产业视图" value="2"></el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
              <div class="among">
                <div class="mark-bottom poli-cell whole-bgt">
                  <div class="whole-bgt-main">
                    <div class="poli_head whole-bgt">
                      <div class="meas-name"><span>存栏量趋势</span></div>
                      <div class="meas-input">
                        <!-- <el-select
                        v-model="trendValue"
                        placeholder="全部"
                        @change="handleTrendChange"
                        popper-class="selectPopper"
                        :popper-append-to-body="false"
                      >
                        <el-option
                          v-for="item in selectOption"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select> -->
                        <el-date-picker
                            v-model="clYear"
                            type="year"
                            :clearable="false"
                            format="yyyy"
                            value-format="yyyy"
                            placeholder="选择年"/>
                      </div>

                    </div>
                    <trend-line-charts
                      id="trend-line-charts"
                      width="100%"
                      :data="exitTrendData"
                    />
                  </div>
                </div>
                <!-- <div v-if="cattleOrSheep === '1'" class="poli-cell whole-bgt">
                  <div class="poli_head whole-bgt">
                    <div class="meas-name"><span>牛只规模养殖场分布</span></div>
                  </div>
                  <scale-pie-charts
                    width="100%"
                    height="220px"
                    :data="cattleScaleData"
                  />
                </div> -->
                <div v-if="cattleOrSheep === '1'" class="poli-cell whole-bgt">
                  <div class="whole-bgt-main">
                    <div class="poli_head whole-bgt">
                      <div class="meas-name"><span>牛只分类统计</span></div>
<!--                      <div class="meas-input">-->
<!--                        <el-date-picker-->
<!--                            v-model="nFlYear"-->
<!--                            type="year"-->
<!--                            :clearable="false"-->
<!--                            format="yyyy"-->
<!--                            value-format="yyyy"-->
<!--                            placeholder="选择年"/>-->
<!--                      </div>-->
                    </div>
                    <assortPieCharts
                      width="100%"
                      class="assortPieCharts"
                      :data="cattleAssortData"
                    />
                  </div>
                </div>
                <div v-if="cattleOrSheep === '2'" class="poli-cell whole-bgt">
                  <div class="whole-bgt-main">
                    <div class="poli_head whole-bgt">
                      <div class="meas-name"><span>羊只分类统计</span></div>
                      <div class="meas-input">
                        <el-date-picker
                            v-model="nFlYear"
                            type="year"
                            :clearable="false"
                            format="yyyy"
                            value-format="yyyy"
                            placeholder="选择年"/>
                      </div>
                    </div>
                    <assortPieCharts
                      width="100%"
                      class="assortPieCharts"
                      :data="sheepAssortData"
                    />
                  </div>
                </div>
                <!-- <div v-if="cattleOrSheep === '2'" class="poli-cell whole-bgt">
                  <div class="poli_head whole-bgt">
                    <div class="meas-name"><span>羊只规模养殖场分布</span></div>
                  </div>
                  <scale-pie-charts
                    width="100%"
                    height="220px"
                    :data="sheepScaleData"
                  />
                </div> -->
              </div>
            </div>
          </el-col>
          <!-- 右侧 -->
          <el-col class="echartsRight" :span="8">
            <div style="height: 95%; width: 100%">
              <div class="mark-bottom poli-cell whole-bgt">
                <div class="whole-bgt-main">
                  <div class="poli_head whole-bgt">
                    <div class="meas-name"><span>入栏、出栏数据对比</span></div>
                    <div class="meas-input">
                      <el-date-picker
                          v-model="crYear"
                          type="year"
                          :clearable="false"
                          format="yyyy"
                          value-format="yyyy"
                          placeholder="选择年"/>
                    </div>
                  </div>
                  <contrast-bar-charts
                    class="contrast-bar-charts"
                    width="100%"
                    height="100%"
                    :data="contrastData"
                  />
                </div>
              </div>
              <!-- <div class="poli-cell whole-bgt">
                <div class="poli_head whole-bgt">
                  <div class="meas-name"><span>出生、死亡数统计</span></div>
                </div>
                <sta-line-charts
                  width="100%"
                  height="220px"
                  :data="lifeStaData"
                />
              </div> -->
              <div class="poli-cell whole-bgt">
                <div class="whole-bgt-main">
                  <div class="poli_head whole-bgt">
                    <div class="meas-name"><span>防疫接种统计</span></div>
                    <div class="meas-input">
                      <el-date-picker
                          v-model="fyTjYear"
                          type="year"
                          :clearable="false"
                          format="yyyy"
                          value-format="yyyy"
                          placeholder="选择年"/>
                    </div>
                  </div>
                  <div id="myChart8"></div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import HeadNei from "@/components/HeadNei.vue";
import trendLineCharts from "@/components/chart/trendLineCharts";
import contrastBarCharts from "@/components/chart/contrastBarCharts";
import rankBarCharts from "@/components/chart/rankBarCharts";
// import scalePieCharts from "@/components/chart/scalePieCharts";
// import staLineCharts from "@/components/chart/staLineCharts";
import assortPieCharts from "@/components/chart/assortPieCharts";
import * as echarts from "echarts";
import moment from "moment/moment";
export default {
  name: "Home",
  components: {
    HeadNei,
    trendLineCharts,
    rankBarCharts,
    // scalePieCharts,
    // staLineCharts,
    assortPieCharts,
    contrastBarCharts,
  },
  data() {
    return {
      currentRegion: "",
      cattleOrSheep: "1",
      exitTrendData: {},
      contrastData: {},
      cattleScaleData: {},
      sheepScaleData: {},
      cattleAssortData: {},
      lifeStaData: {},
      sheepAssortData: {},
      farmRankData: [],
      selectOption: [],
      rankOption: [],
      trendValue: "all",
      rankValue: ["all"],
      // 存栏
      clYear: moment().format('YYYY'),
      // 牛 分类统计
      nFlYear: moment().format('YYYY'),
      // 入栏、出栏数据对比
      crYear: moment().format('YYYY'),
      // 防疫接种统计
      fyTjYear: moment().format('YYYY'),
      centerTimeRefresh: null,
    };
  },
  computed: {
    farmRankHeight() {
      return this.farmRankData.length <= 20
        ? this.farmRankData.length * 25 + 100 + "px"
        : "100%";
    },
  },
  watch: {
    clYear(){
      this.initChart(this.currentRegion);
    },
    // nFlYear(){
    //   if (this.cattleOrSheep == '2'){
    //     this.initChart2(this.currentRegion);
    //
    //   }else {
    //     this.initChart1(this.currentRegion);
    //   }
    // },
    crYear(){
      this.initChart7();
    },
    fyTjYear(){
      this.initChart8();
    },
  },

  mounted() {
    this.initData();
    this.dataRefresh();
  },

  beforeDestroy() {
    this.clear();
  },

  methods: {
    handleChangeRegion(e) {
      this.initChart6(this.currentRegion, { type: this.cattleOrSheep });
      this.initChart7();
      this.initChart8();
      let code = e;
      console.log(code, "code");
      this.initChart1(code);
      this.initChart(code);
      console.log("事件", this.farmRankHeight);
      console.log("data", this.farmRankData.length);
    },

    handleChangeType() {
      this.initChart6(this.currentRegion, { type: this.cattleOrSheep });
      this.initChart7();
      this.initChart8();
    },
    dataRefresh() {
      if (this.centerTimeRefresh != null) {
        return;
      }
      this.centerTimeRefresh = setInterval(() => {
        this.initData();
      }, 1800000);
    },

    clear() {
      clearInterval(this.centerTimeRefresh);
      this.centerTimeRefresh = null;
    },

    initData() {
      this.initSelectOptions();
      // 存栏量趋势
      this.initChart("all");
      // 牛只分类统计
      this.initChart1();
      // 羊只分类统计
      this.initChart2();
      // 牛规模养殖场分布
      this.initChart4_cattle();
      // 羊规模养殖场分布
      this.initChart4_sheep();
      // 出生、死亡数统计
      this.initChart5();
      // 养殖场畜禽排行
      this.initChart6(this.currentRegion, { type: this.cattleOrSheep });
      // 入栏、出栏数据对比
      this.initChart7();
      // 防疫接种统计
      this.initChart8();
  /*    // 主要饲料消耗量统计
      this.initChart9();*/
    },

    // 下拉框数据请求
    async initSelectOptions() {
      const { result } = await this.$api.screen.screenSelectOptions();
      let selectOptions = result.map((item) => {
        return {
          value: item.regionCode,
          label: item.regionName,
        };
      });
      selectOptions.unshift({
        value: "",
        label: "全部",
      });
      let rankOptions = JSON.parse(JSON.stringify(selectOptions));
      rankOptions.map((item) => {
        if (item.value !== "all") {
          item.children = [
            {
              value: "0",
              label: "全部",
            },
            {
              value: "1",
              label: "牛",
            },
            {
              value: "2",
              label: "羊",
            },
            {
              value: "3",
              label: "鸡",
            },
          ];
        }
      });
      this.rankOption = rankOptions;
      this.selectOption = selectOptions;
    },
    // 存栏量趋势
    async initChart(code) {
      const params = code === "all" ? "" : code;
      let { result } = await this.$api.screen.screenExistTrend(params, this.clYear);
      console.log(111, result)
      this.exitTrendData = result
      // this.exitTrendData = {
      //   month: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
      //   cattleCount: [82098, 92098, 102098, 86098, 92098, 95698, 98098, 82598, 82098, 0, 0, 0],
      //   // otherCount: [],
      //   poultryCount: [72098, 62098, 88098, 76098, 86098, 65678, 75098, 100598, 85098, 0, 0, 0],
      //   sheepCount: [502098, 508098, 490098, 506098, 500098, 390698, 406098, 322598, 432098, 0, 0, 0],
      // };
      console.log("wuidhsaiudhsui");
    },
    handleTrendChange(val) {
      this.initChart(val);
    },

    // 牛只分类统计
    async initChart1(code) {
      console.log(code, "codecodecode");
      const params = {
        regionCode: code,
        type: "1",
        // year: this.nFlYear,
      };
      console.log(code,params, "codecodecode");
      let { result } = await this.$api.center.dataAssortSta(params);
/*      let result= {
    "totalCount": 49157,
    "keyValues": [
        {
            "name": "基础母牛",
            "value": 47900
        },
        {
            "name": "奶牛",
            "value": 1257
        }
    ]
}*/
      this.cattleAssortData = result;
      console.log("hahahahahahah",result);
    },


    // 羊只分类统计
    async initChart2() {
      let { result } = await this.$api.center.dataAssortSta({ type: "2" });
      this.sheepAssortData = result;
    },

    // 规模养殖场分布
    async initChart4_cattle() {
      let { result } = await this.$api.center.dataDistribution({ type: "1" });
      this.cattleScaleData = result;
    },
    async initChart4_sheep() {
      let { result } = await this.$api.center.dataDistribution({ type: "2" });
      this.sheepScaleData = result;
    },
    // 出生、死亡数统计
    async initChart5() {
      let { result } = await this.$api.center.dataBirthDead();
      this.lifeStaData = result;
    },
    // 养殖场畜禽排行
    async initChart6(code, params) {
      // async initChart6() {
      // eslint-disable-next-line no-unused-vars
      this.farmRankData = [];
      let { result } = await this.$api.center.dataLivestockRank(code, params);
      // let myChart6 = this.$echarts.init(document.getElementById("myChart6"));
      // console.log(result);
      this.farmRankData = result;

      console.log(this.farmRankData.length);

      /*  for (let i = 0; i < 21; i++) {
        this.farmRankData.push({
          count: i + 2,
          farmName: `hello${i}`,
        });
      }*/

      // console.log("this.farmRankData", this.farmRankData);
      // console.log("this.farmRankHeight", this.farmRankHeight);

      // let myChart6 = this.$echarts.init(document.getElementById("myChart6"));
      // myChart6.setOption({
      //   // dataZoom: [
      //   //   {
      //   //     type: "slider",
      //   //     yAxisIndex: [0],
      //   //     filterMode: "empty",
      //   //   },
      //   // ],
      // });
    },
    handleRankChange(val) {
      if (val[0] !== "all") {
        if (val[1] !== "0") {
          this.initChart6(val[0], { type: val[1] });
        } else {
          this.initChart6(val[0], {});
        }
      } else {
        this.initChart6("", {});
      }
    },

    // 入栏、出栏数据对比
    async initChart7() {
      const params = {
        regionCode: this.currentRegion,
        breedType: this.cattleOrSheep,
        year: this.crYear,
      };
      let { result } = await this.$api.center.dataAccessContrast(params);
      console.log('入栏出栏数据对比',result);
      this.contrastData = result;
      /*this.contrastData =    {
        "month": [1, 2, 3, 4],
        "enterCount": [16, 8, 20, 0],
        "exitType": [11, 16, 10, 0]
      }*/

    },
    // 防疫接种统计
    async initChart8() {
      let myChart8 = this.$echarts.init(document.getElementById("myChart8"));
      const params = {
        regionCode: this.currentRegion,
        breedType: this.cattleOrSheep,
        year: this.fyTjYear,
      };
      const { result } = await this.$api.center.dataEpidemicAndPrevention(params);

      console.log(result);

      const { month, inoculationCount, existCount } = result;

      // 已接种
      // let zzx1 = [55000, 60000, 45000, 0];
      let zzx1 = inoculationCount;
      // var zx = zzx1.map((item) => {
      // 	return 100 - item;
      // });
      // 存栏量
      // let wgx1 = [20800, 50700, 39000, 0];
      let wgx1 = existCount;
      // var wg = wgx1.map((item) => {
      // 	return 100 - item;
      // });

      // let month = ["第一季度", "第二季度", "第三季度", "第四季度"];

      let barWidth = "14px";
      myChart8.setOption({
        // dataZoom: [
        //   {
        //     type: "inside",
        //     realtime: true,
        //   },
        //   {
        //     show: true,
        //     xAxisIndex: [0],
        //     realtime: true,
        //     height: 4, //这里可以设置dataZoom的尺寸
        //     bottom: "2%",
        //     backgroundColor: "#1d76e6", // 填充颜色
        //     textStyle: {
        //       color: "#fff", // 左右两边文字颜色
        //     },
        //   },
        // ],
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(0, 0, 0, 0.63)", //设置背景颜色
          textStyle: {
            color: "#fff",
          },
          borderColor: "rgba(255,255,255, .5)",
          axisPointer: {
            type: "shadow",
          },
          formatter: "{b}季度<br>已接种：{c}<br>存栏量：{c1}",
        },
        grid: {
          left: "5%",
          right: "15%",
          bottom: "5%",
          top: "15%",
          containLabel: true,
        },
        legend: {
          data: ["已接种", "存栏量"],
          icon: "rect",
          right: "2%",
          textStyle: {
            color: "#fff",
            fontSize: 14,
          },
          itemWidth: 14,
          itemHeight: 4,
          itemGap: 35,
          color: "#fff",
          selectedMode: false,
        },
        xAxis: {
          type: "category",
          name: "季度",
          data: month,
          nameTextStyle: {
            color: "#b5dbff",
            fontSize: "14px",
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(45, 60, 92, 1)",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              fontFamily: "Microsoft YaHei",
              color: "#b5dbff", // x轴颜色
              fontWeight: "normal",
              fontSize: "14",
              lineHeight: 22,
            },
            interval: 0, //标签设置为全部显示
            lineHeight: 15,
          },
        },
        yAxis: [
          {
            // min: 0,
            // max: 100000,
            type: "value",
            name: "头",
            nameTextStyle: {
              color: "#b5dbff",
              fontSize: "14px",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(45, 60, 92, 1)",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(45, 60, 92, .3)", //左侧显示线
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              //  formatter: "{value}%",
              textStyle: {
                color: "#b5dbff",
                fontSize: 14,
              },
            },
          },
        ],
        series: [
          // 已接种中间正方形
          {
            type: "pictorialBar",
            symbol: "diamond",
            symbolSize: [barWidth, 8],
            symbolOffset: [-8, -4],
            symbolPosition: "end",
            z: 12,
            color: "#01bd62",
            data: zzx1,
          },
          // 存栏量中间正方形
          {
            type: "pictorialBar",
            symbol: "diamond",
            symbolSize: [barWidth, 8],
            symbolOffset: [8, -4],
            symbolPosition: "end",
            z: 12,
            color: "#a565e4",
            data: wgx1,
          },
          //  已接种正方形
          {
            type: "pictorialBar",
            symbol: "diamond",
            symbolSize: [barWidth, 8],
            symbolOffset: [-8, -4],
            z: 12,
            color: "rgba(0, 187, 233, 0)",
            data: zzx1,
          },
          // 存栏量正方形
          {
            type: "pictorialBar",
            symbol: "diamond",
            symbolSize: [barWidth, 8],
            symbolOffset: [8, -4],
            color: "rgba(252,171,43,0)",
            z: 12,
            data: wgx1,
          },
          // 已接种进度柱子
          {
            name: "已接种",
            type: "bar",
            barWidth: barWidth,
            // zlevel: 2,
            stack: "1",
            itemStyle: {
              normal: {
                opacity: 0.7,
                color: "#01bd62",
              },
            },
            label: {
              show: false,
              position: ["-18", "-18"],
              color: "#01bd62",
              fontSize: 12,
            },
            data: zzx1,
          },
          // 存栏量进度柱子
          {
            name: "存栏量",
            type: "bar",
            stack: "4",
            barWidth: barWidth,
            itemStyle: {
              normal: {
                opacity: 0.7,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#a565e4",
                  },
                  {
                    offset: 1,
                    color: "#a565e4",
                  },
                ]),
                barBorderRadius: 0,
              },
            },
            label: {
              show: false,
              position: ["18", "-18"],
              color: "#a565e4",
              fontSize: 12,
            },
            data: wgx1,
          },
        ],
      });
    },


    /*//主要饲料消耗量统计
    async initChart9() {
      let { result } = await this.$api.center.dataFeedReport();
      console.log("result----", result);
      let myChart9 = this.$echarts.init(document.getElementById("myChart9"));
      myChart9.setOption({
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["粗饲料", "精饲料", "青绿饲料", "其他饲料"],
          icon: "rect", //rect方形
          itemWidth: 14, // 设置宽度
          itemHeight: 4, // 设置高度
          itemGap: 20, // 设置间距
          textStyle: {
            color: "#ffffff",
            fontSize: 14,
          },
          right: "2%",
        },
        grid: {
          top: "14%",
          left: "0%",
          right: "6%",
          bottom: "2%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          name: "季度",
          nameTextStyle: {
            color: "#b5dbff",
            fontSize: "14px",
          },
          boundaryGap: false,
          data: result.month,
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#b5dbff",
            fontSize: 14,
          },
        },
        yAxis: {
          type: "value",
          name: "公斤",
          nameTextStyle: {
            color: "#b5dbff",
            fontSize: "14px",
          },
          min: 0,
          // max: 50,
          axisLine: {
            show: true,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            color: "#b5dbff",
            fontSize: 14,
          },
        },
        series: [
          {
            name: "粗饲料",
            type: "line",
            // stack: 'Total',
            showSymbol: false,
            data: result.roughCount,
            itemStyle: {
              color: "#00bbe9",
              lineStyle: {
                color: "#00bbe9",
              },
            },
          },
          {
            name: "精饲料",
            type: "line",
            // stack: 'Total',
            showSymbol: false,
            data: result.fineCount,
            itemStyle: {
              color: "#fcab2b",
              lineStyle: {
                color: "#fcab2b",
              },
            },
          },
          {
            name: "青绿饲料",
            type: "line",
            // stack: 'Total',
            showSymbol: false,
            data: result.clearGreenCount,
            itemStyle: {
              color: "#2dad83",
              lineStyle: {
                color: "#2dad83",
              },
            },
          },
          {
            name: "其他饲料",
            type: "line",
            // stack: 'Total',
            showSymbol: false,
            data: result.otherCount,
            itemStyle: {
              color: "#4f52b7",
              lineStyle: {
                color: "#4f52b7",
              },
            },
          },
        ],
      });
    },*/
  },
};
</script>
<style scoped>
.m-select-group {
  display: flex;
  justify-content: center;
}

.m-select-group /deep/ .el-input__inner {
  background-color: rgba(31, 158, 204, 0.2);
  border-color: #00bbe9 !important;
  /* border-radius: 0; */
  width: 100%;
  height: 50px;
  line-height: 50px;
  color: #e2ebf1;
  font-size: 20px;
  font-weight: bold;
  padding: 0 10px;
}
.warpper {
  background: url(../assets/images/po-bj.png), #091f36;
  background-size: 100% 100%;
  //border: 1px solid red;
  position: fixed;
  width: 100%;
  height: 100%;
}

/* 图表内容 */
.content {
  padding: 0 36px 0;
  //border: 1px solid red;
  height: calc(100% - 110px);
}
.content .meas_box {
  //border: 1px  solid red;
  height: 100%;
}
.content .meas_box .el-row {
  //border: 1px solid red;
  position: relative;
  height: 100%;
  margin: 0 auto;
}

/* 左侧图表样式 */
.content .meas_box .el-row .echartsLeft {
  //border: 1px solid red;
  height: 100%;
  position: relative;
}

/* 中间图表样式 */
.content .meas_box .el-row .echartsCenter {
  //border: 1px solid red;
  height: 100%;
  position: relative;
}
.content .meas_box .el-row .echartsCenter .top {
  //border: 1px solid red;
  height: 70px;
}
.content .meas_box .el-row .echartsCenter .among {
  height: calc(100% - 70px);
}
.content .meas_box .el-row .echartsCenter .among .poli-cell {
  //border: 1px solid red;
  margin-top: 0;
  height: 48%;
  padding: 0;
}
.content .meas_box .el-row .echartsCenter .among .poli-cell .whole-bgt-main {
  //border: 1px solid #00ff19;
  position: relative;
  height: 100%;
}
.content
  .meas_box
  .el-row
  .echartsCenter
  .among
  .poli-cell
  .whole-bgt-main
  .poli_head {
  margin-bottom: 15px;
}
.content
  .meas_box
  .el-row
  .echartsCenter
  .among
  .poli-cell
  .whole-bgt-main
  #trend-line-charts {
  position: absolute;
  width: 100%;
  height: calc(100% - 45px);
}
.content
  .meas_box
  .el-row
  .echartsCenter
  .among
  .poli-cell
  .whole-bgt-main
  .assortPieCharts {
  position: absolute;
  width: 100%;
  height: calc(100% - 45px);
}

/* 右侧图表样式 */
.content .meas_box .el-row .echartsRight {
  //border: 1px solid red;
  height: 100%;
  position: relative;
}
.content .meas_box .el-row .echartsRight .poli-cell {
  //border: 1px solid red;
  margin-top: 0;
  height: 48%;
  padding: 0;
}
.content .meas_box .el-row .echartsRight .poli-cell .whole-bgt-main {
  //border: 1px solid #00ff19;
  position: relative;
  height: 100%;
}
.content .meas_box .el-row .echartsRight .poli-cell .whole-bgt-main .poli_head {
  margin-bottom: 15px;
}
.content
  .meas_box
  .el-row
  .echartsRight
  .poli-cell
  .whole-bgt-main
  .contrast-bar-charts {
  position: absolute;
  width: 100%;
  height: calc(100% - 45px);
}

.content .meas_box .el-row .echartsRight .poli-cell .whole-bgt-main #myChart8 {
  position: absolute;
  width: 100%;
  height: calc(100% - 45px);
}

/* 公用样式 */
.content .meas_box .el-row .mark-bottom {
  margin-bottom: 5%;
}

.poli-cell {
  width: 100%;
  height: 300px;
  background-image: url(../assets/images/meas1.png);
  padding: 20px;
  margin-top: 20px;
}

.meas-cell {
  width: 442px;
  height: 216px;
  background-image: url(../assets/images/meas2.png);
  margin: 30px 0;
}
#rank {
  height: 95%;
  margin-top: 0;
}
.poli_head {
  /* width: 540px; */
  height: 28px;
  line-height: 20px;
  background-image: url(../assets/images/meas3.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: 0 auto 20px;
  position: relative;
  padding-left: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.meas-head {
  width: 380px;
  background-image: url(../assets/images/meas4.png);
}

.poli_head /deep/ .el-select {
  //position: absolute;
  //top: -8px;
  //right: 8px;
}

.poli_head /deep/ .el-input__inner {
  background-color: rgba(31, 158, 204, 0.2);
  border-color: #00bbe9 !important;
  border-radius: 0;
  width: 102px;
  height: 30px;
  line-height: 30px;
  color: #e2ebf1;
  font-size: 14px;
  padding: 0 10px;
}

.poli_head /deep/ .el-input__icon {
  line-height: 30px;
}
.poli_head /deep/.selectPopper {
  /* background-color: rgba(31, 158, 204, 0.2); */
  background-color: rgba(9, 48, 106);
  border-color: #00bbe9 !important;
}

.poli_head /deep/ .selected {
  color: #ffffff !important;
}

.poli_head /deep/ .el-select-dropdown__item {
  color: #00bbe9;
}

.poli_head /deep/ .hover {
  color: #ffffff !important;
  background-color: rgba(31, 158, 204, 0.5);
}

.poli_head /deep/.el-cascader__dropdown {
  background-color: rgba(9, 48, 106);
  border-color: #00bbe9 !important;
}
/* .poli_head /deep/.in-checked-path{
	color: #ffffff !important;
	background-color: rgba(9, 48, 106,0.5);
} */
.poli_head /deep/ .el-cascader-node {
  color: #00bbe9;
}
.poli_head /deep/.is-active {
  color: #ffffff !important;
}
.poli_head >>> .in-active-path {
  color: #ffffff !important;
  background-color: rgba(31, 158, 204, 0.5);
}
.poli_head >>> .el-cascader-node:hover {
  color: #ffffff !important;
  background-color: rgba(31, 158, 204, 0.5);
}
#rankCascader {
  position: absolute;
  top: -12px;
  right: 8px;
}

#rankCascader /deep/ .el-input__inner {
  width: 136px !important;
}

.meas-name span {
  font-size: 20px;
  background-image: -webkit-linear-gradient(top, #4bbaef, #ffffff);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
  transform: skewX(-10deg);
  display: block;
  width: max-content;
}

.meas-input{
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  top: -5px;
}

.meas-input .el-input{
  width: max-content;
}

.meas-input .el-input /deep/ .el-input__inner{
  text-align: center;
}

#myChart7,
#myChart8,
#myChart9 {
  width: 100%;
  height: 220px;
}

#myChart2,
#myChart3 {
  width: 100%;
  height: 130px;
}
</style>
